import * as actionType from '../action-type';

const initialState = {
  data: {
    stepOneTogg: ['1', '2', '3', '4', '5', '6', '7', '8'],
    stepThreeTogg: ['1', '2', '3', '4'],
    stepFourTogg: ['6', '7', '8', '10'],
    attachments: [],
    Allimagedescription: {},
    footerLogo: [],
    claim_his_togg: true,
    observe_togg: true,
    app_field_togg: true,
    indus_stand_togg: true,
    conc_togg: true,
    cause_togg: false,
    manufacturing_issue_togg: false,
    site_rel_issue_togg: false,
    perfo_rel_issue_togg: false,
    insta_rel_issue_togg: false,
    confi: false,
    upload_sign_toggle: false,
    footer_text_info: false,
    private_notes_togg: false,
    footer_info_toggle: false,
  },
};

const nwfaInstallationReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_NWFA_INSTALLATION_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actionType.RESET_NWFA_INSTALLATION_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default nwfaInstallationReportReducer;